module.exports = __webpack_public_path__ + "img/icon_common_empty_icon_new.2188a2a7.png";